// table-controls.component.ts
import { CommonModule } from '@angular/common';
import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule, UntypedFormGroup } from '@angular/forms';

@Component({
  selector: 'app-table-controls',
  templateUrl: './table-controls.component.html',
  styleUrls: ['./table-controls.component.scss'],
  standalone: true,
  imports: [
    CommonModule, 
    ReactiveFormsModule
  ]
})
export class TableControlsComponent implements OnInit {
  // Inputs
  @Input() currentLimit = Number(10);
  @Input() searchPlaceholder = String('Search');
  @Input() showLimitControl = Boolean(true);
  @Input() showSearchControl = Boolean(true);
  @Input() customClass = '';
  @Input() marginTop = 'mt-10';

  @Output() limitChangeEvent = new EventEmitter<any>();
  @Output() searchKeyupEvent = new EventEmitter<any>();
  @Output() keydownEvent = new EventEmitter<any>();

  limitForm!: UntypedFormGroup;
  searchForm!: UntypedFormGroup;
  private searchDebounce: any = null;

  constructor(private fb: FormBuilder) {}

  ngOnInit(): void {    
    this.limitForm = this.fb.group({
      limit: [this.currentLimit]
    });

    this.searchForm = this.fb.group({
      search: ['']
    });
  }

  onLimitChange(event: any): void {
    this.limitChangeEvent.emit(event);
  }

  onSearchKeyup(event: any): void {
    clearTimeout(this.searchDebounce);
    this.searchDebounce = setTimeout(() => {
      this.searchKeyupEvent.emit(event);
    }, 500);
  }

  onKeyDown(event: any): void {
    this.keydownEvent.emit(event);
  }


  clearSearch(): void {
    this.searchForm.patchValue({ search: '' });
    this.searchKeyupEvent.emit({ target: { value: '' } });
  }

}
